import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import ModalHost from "@/components/ui/ModalHost";
import Login from "@/pages/Login";
import FrentistaApp from "@/pages/FrentistaApp";
import MasterApp from "@/pages/Master/MasterApp";
import PreviewModerno from "@/pages/PreviewModerno";
import Pesquisa from "@/pages/Pesquisa";
import IndicacaoPublica from "@/pages/IndicacaoPublica";
import OfflineIndicator from "@/components/OfflineIndicator";
import Loader from "@/components/Loader";

function RequireFrentista({ children }) {
  const { frentista, loading } = useAuth();
  if (loading) return <Loader />;
  if (!frentista) return <Navigate to="/frentista/login" replace />;
  return children;
}

function RequireMaster({ children }) {
  const { masterAuth, loading } = useAuth();
  if (loading) return <Loader />;
  if (!masterAuth) return <Navigate to="/master/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/frentista/login" element={<Login initialRole="frentista" />} />
            <Route path="/frentista/*" element={<RequireFrentista><FrentistaApp /></RequireFrentista>} />
            <Route path="/master/login" element={<Login initialRole="master" />} />
            <Route path="/master/*" element={<RequireMaster><MasterApp /></RequireMaster>} />
            <Route path="/pesquisa/:aid" element={<Pesquisa />} />
            <Route path="/preview/moderno" element={<PreviewModerno />} />
            {/* Fase 4 (pedido de 19/10, item 9): página PÚBLICA e isolada da indicação pela web.
                Só publicApi; o token da página fica em memória. Sem unidade: aviso genérico. */}
            <Route path="/indicacao/:unidade" element={<IndicacaoPublica />} />
            <Route path="/indicacao" element={<IndicacaoPublica />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <OfflineIndicator />
        </div>
        <ModalHost />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
